import { GridCustomFilterCellProps } from '@progress/kendo-react-grid';
import { GetString } from '../StringResourceManager';
import {
  getScheduledCommandStatusOptions,
  scheduledCommandStatusTextMap,
  scheduledCommandStatusToTypeMap,
} from '../../utils/textMappings';
import { ScheduledCommandDropdownFilterCell } from '../ScheduleCommandDropdownFilterCell';

export const ScheduledStatusDropDownFilterCell: any = (
  props: GridCustomFilterCellProps,
) => (
  <ScheduledCommandDropdownFilterCell
    {...props}
    data={getScheduledCommandStatusOptions()}
    defaultItem={GetString('SELECT_STATUS')}
    onChangeValueCheckFunc={scheduledCommandStatusToTypeMap}
    commandStatusTextMap={scheduledCommandStatusTextMap}
  />
);
